import { useQuery } from '@tanstack/react-query';
import { api } from '@/auth/api';
import { qk } from '@/data/query-keys';

/** S69 — the signed-in user's own private profile (role included). */
export interface Me {
  id: string;
  handle: string;
  displayName: string;
  role: 'driver' | 'platform_admin';
}

export function useMe() {
  return useQuery({
    queryKey: qk.me.profile(),
    queryFn: async () => {
      const res = await api<{ user: Me }>('/v1/me');
      return res.user;
    },
    staleTime: 5 * 60_000,
  });
}

export function useIsPlatformAdmin(): boolean {
  const me = useMe();
  return me.data?.role === 'platform_admin';
}
